declare namespace $ {

	type $shm_ba_agent_message_text__text_shm_dashboard_opencode_app_1 = $mol_type_enforce<
		ReturnType< $shm_dashboard_opencode_app['message_text'] >
		,
		ReturnType< $shm_ba_agent_message_text['text'] >
	>
	export class $shm_dashboard_opencode_app extends $shm_opencode_app {
		sessions_title( ): string
		dashboard( ): $shm_ba_dashboard_model | null
		dashboard_id( ): string
		dashboard_title( ): string
		Message_text( id: any): $shm_ba_agent_message_text
	}
	
}

//# sourceMappingURL=app.view.tree.d.ts.map